import { makeActionCreator } from '../../../utils/actionsUtils';
import { REQUEST_LOGOUT, SUCCESS_LOGOUT } from './constants';

import { forceFetchPartners } from '../../partner/actions';
import { resetInfos } from '../../account/actions';
import { DOMAIN_COOKIE } from '../../../constants';
import { COOKIE_KEY_ACCESS, COOKIE_KEY_ID, COOKIE_KEY_USERNAME } from '../../../constants/cookie';

// indique qu'une demande de logout a été faite au serveur
const requestLogout = makeActionCreator(REQUEST_LOGOUT);

// indique que la demande de logout a été acceptée
const successLogout = makeActionCreator(SUCCESS_LOGOUT);

// indique que la demande de lougout a été refusée et on envoie avec un message d'erreur
//const failureLogout = makeActionCreator(FAILURE_LOGOUT, 'message');

/**
 * Execute un appel AJAX vers le serveur pour faire une demande de logout
 * Envoie au serveur le token du membre
 * /!\ Attention cette API est pour l'instant non développé côté serveur donc il ne faut pas l'utiliser tant que rien n'ai fait coté serveur /!\
 * @param {String} token
 *
 */
/*
function logoutServerUser(token) {

    const config = {
        method: HTTP_METHOD_GET
    };

    return dispatch => {
        dispatch(requestLogout());

        return fetch(`${API_ROOT}/auth?token=${token}`, config)
            .then(response => response.json().then(json => ({ status: json.status, payload: json.payload, message: json.message, response })))
            .then(({ status, payload, message, response }) => {
                if (response.status === RESPONSE_STATUS_CODE_200 && response.ok && _.isEqual(status, RESPONSE_STATUS_SUCCESS)) {
                    // demande de logout acceptée
                    dispatch(successLogout());
                    dispatch(resetInfos());
                } else {
                    // demande de logout refusée
                    dispatch(failureLogout(message));
                    return Promise.reject(payload);
                }
            }).catch(err => {
                console.error('Error: ', err);
                dispatch(failureLogin(err));
            });
    }
}
*/

const deleteCookie = name => {
    document.cookie =
        name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' + DOMAIN_COOKIE;
};

export function deleteCookies() {
    deleteCookie(COOKIE_KEY_USERNAME);
    deleteCookie(COOKIE_KEY_ACCESS);
    deleteCookie(COOKIE_KEY_ID);
}

/**
 * Sign out user on front end (Delete token from localstorage)
 */
export function logoutUser(callback) {
    return dispatch => {
        dispatch(requestLogout());
        dispatch(successLogout());
        deleteCookies();
        dispatch(resetInfos());
        dispatch(forceFetchPartners());
        if (callback) {
            callback();
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/authentication/logout/actions.js